import "./Treatments.module.css";
import Header from "@/reusable_sections/Header";
import ANewStandard from "./sections/ANewStandard";
import YourTreatmentPlan from "./sections/YourTreatmentPlan";
import ConsultationInquiry from "./sections/ConsultationInquiry";
import Footer from "@/reusable_sections/Footer";
export default function TreatmentsPage() {
  return <div>
      <Header />
      <ANewStandard />
      <YourTreatmentPlan />
      <ConsultationInquiry />
      <Footer />
    </div>;
}